import * as React from "react";
import { ReactNode } from "react";

interface Props {
    name?: string;
    children?: ReactNode;
}

export const SuccessAlert: React.FC<Props> = (props) => (
    <div className="alert alert-success" role="alert">
        <i className="icon-check-circle"></i>
        {props.children}
    </div>
);

export const InfoAlert: React.FC<Props> = (props) => (
    <div className="alert alert-info" role="alert">
        <i className="icon-alert-triangle"></i>
        {props.children}
    </div>
);

export const WarningAlert: React.FC<Props> = (props) => (
    <div className="alert alert-warning" role="alert">
        <i className="icon-alert-triangle"></i>
        {props.children}
    </div>
);

export const DangerAlert: React.FC<Props> = (props) => (
    <div className="alert alert-danger" role="alert" {...props}>
        <i className="icon-alert-triangle"></i>
        {props.children}
    </div>
);



// WEBPACK FOOTER //
// ./ClientApp/components/common/Alerts.tsx